import { render, staticRenderFns } from "./totalPatiensInsurance.vue?vue&type=template&id=39053d88"
import script from "./totalPatiensInsurance.vue?vue&type=script&lang=js"
export * from "./totalPatiensInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports